export default __webpack_public_path__ + "static/media/thumbnail.88a362fc.png";